<template>
  <base-popup
      :popup-model="show"
      :title="formTitle"
      :valid="!valid"
      @onCancelButtonClick="closePopupHandler"
      @onSaveButtonClick="saveItemHandler"
  >
    <v-form
        :ref="formRef"
        v-model="valid"
        lazy-validation
    >
      <v-container>
        <v-layout>
          <v-flex xs12>
            <v-text-field
                v-model="currentItem.name"
                :rules="requiredFieldRule"
                label="Name"
                prepend-icon="mdi-rename-box"
                required
            />
            <v-select
                v-model="currentItem.type"
                :rules="requiredFieldRule"
                :items="items"
                prepend-icon="mdi-wrap"
                label="Type"
            />
            <v-layout class="custom-switch-btn" row>
              <v-flex xs3>
                <v-subheader class="switch-btn-title">Status</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-switch
                    v-model="currentItem.isActive"
                    color="primary"
                    dense
                    inset
                    prefix="Status">
                </v-switch>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </base-popup>
</template>
<script>
import BasePopup from "./BasePopup";
import PopupMixin from "../mixins/Popup";

export default {
  name: 'MethodPopup',
  components: {BasePopup},
  mixins: [PopupMixin],
  data() {
    return {
      items: ['online', 'manual']
    }
  },
  computed: {
    formTitle() {
      return this.isEditMode
          ? 'Edit Method'
          : 'Add Method'
    }
  }
}
</script>
